<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="80%"
      title="场馆"
      :close-on-click-modal="false"
    >
      <el-form
        :model="form"
        label-width="auto"
        :rules="rules"
        ref="courseForm"
        style="display: flex; justify-content: space-around; flex-wrap: wrap"
      >
        <div>
          <el-form-item label="所属空间">
            <el-select
              v-model="form.mechanismName"
              :placeholder="curSpace || '输入机构名称或手机号'"
              filterable
              clearable
              remote
              :remote-method="searchOrgName"
            >
              <el-option
                v-for="(item, index) in mechanism_name_list"
                :key="index"
                :label="item.name"
                :value="item.id"
                @click.native="changeMec(item)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场馆名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="类目">
            <el-select
              v-model="form.categories_child"
              :placeholder="form.categories_child || '场馆类目'"
              clearable
            >
              <el-option
                v-for="(item, index) in categories_child_list"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省市区" required>
            <city-select @change="changeCity" :temp="cityList"></city-select>
          </el-form-item>
          <el-form-item label="详细地址" required>
            <el-input v-model="form.address">
              <addr-select
                slot="append"
                @getform="addMecAddr"
                type="icon"
              ></addr-select>
            </el-input>
          </el-form-item>
          <el-form-item label="经度">
            <el-input v-model="form.longitude" placeholder="经度"></el-input>
          </el-form-item>
          <el-form-item label="纬度">
            <el-input v-model="form.latitude" placeholder="纬度"></el-input>
          </el-form-item>

          <el-form-item label="营业时间">
            <el-input
              v-model="form.banking_hours"
              placeholder="如：周一至周日08:00-22:00"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="form.phone" placeholder="场馆电话"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="是否共享">
            <el-radio-group v-model="form.sharing">
              <el-radio label="share">共享</el-radio>
              <el-radio label="no">不共享</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="系统服务费"
            v-if="form.sharing == 'share'"
          >
            <el-input
              v-model="form.sys_service_ratio"
              placeholder="系统服务费"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面" ref="imgUpRef" required>
            <avatar-uploader
              @getImgUrl="getCover"
              :url="form.images"
              :clear="if_clear"
            ></avatar-uploader>
          </el-form-item>
          <el-form-item label="详情图片">
            <images-uploader
              @getImgUrl="getProductImg"
              :urls="form.introduction_pic"
              :clear="if_clear"
            >
            </images-uploader>
          </el-form-item>
          <el-form-item label="简介">
            <el-input
              type="textarea"
              v-model="form.introduction_content"
              placeholder="简介"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="预约须知">
            <el-input
              type="textarea"
              v-model="form.appointment_notice"
              placeholder="预约须知"
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},

      temp: {},
      rules: rules,
      addServiceDialog: false,
      select_mechanism: "",
      mechanism_name_list: [],
      venues_list: "",
      if_clear: true,
      count: 1,
      cityList: [],
      dev_coach: "",
      categories_child_list: [],
      curSpace: "",
    };
  },

  mounted() {
    this.getCateList();
  },

  methods: {
    getCateList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: "space",
      };
      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          this.categories_child_list = res.data.data;
        });
    },

    // 新增机构地址
    addMecAddr(addr) {
      if (addr.address) {
        this.$set(this.form, "province", addr.province);
        this.$set(this.form, "city", addr.city);
        this.$set(this.form, "district", addr.district);
        this.$set(this.form, "address", addr.address);
        this.cityList = [];
        this.cityList.push(addr.province);
        this.cityList.push(addr.city);
        this.cityList.push(addr.district);
      }

      this.$set(this.form, "latitude", addr.addrPoint.lat);
      this.$set(this.form, "longitude", addr.addrPoint.lng);
    },
    changeCity(v) {
      this.cityList = v;
      this.form.province = v[0];
      this.form.city = v[1];
      this.form.district = v[2];
    },
    changeMec(e) {
      this.form.mechanismName = e.mechanism_name;
      this.cityList = [];
      this.cityList.push(e.province);
      this.cityList.push(e.city);
      this.cityList.push(e.district);
      this.$set(this.form, "province", e.province);
      this.$set(this.form, "city", e.city);
      this.$set(this.form, "district", e.district);
      this.$set(this.form, "latitude", e.latitude);
      this.$set(this.form, "longitude", e.longitude);
      this.$set(this.form, "address", e.mechanism_addr);
      this.$set(this.form, "space_id", e.id);
    },
    editService() {
      this.cityList = [];
      this.form = this.Data;
      this.cityList.push(this.Data.province);
      this.cityList.push(this.Data.city);
      this.cityList.push(this.Data.district);
      this.temp.data = { ...this.form };
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.cityList = [];
        this.cityList.push(info.province);
        this.cityList.push(info.city);
        this.cityList.push(info.district);
        if (info.map.space) {
          this.curSpace = info.map.space.name;
        } else {
          this.curSpace = "";
        }
      } else {
        this.form = {};
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/shared/sharedVenue/insert";
      this.if_clear = false;
      this.form.status = 2;
      this.form.sharing = "share";
      this.$axios.post(url, this.form).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: "warning", message: "添加成功!" });
          this.addServiceDialog = false;
          this.if_clear = true;
          this.form = {};
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: res.data.message });
        }
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      data.status = 2;
      this.if_clear = false;
      let url = "/shared/sharedVenue/update";
      this.form.deduction_course_num = 1;
      this.$axios.post(url, data).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: "success", message: "修改成功!" });
          this.addServiceDialog = false;
          this.if_clear = true;
          this.form = {};
          this.temp = {};
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: res.data.message });
        }
      });
    },
    // 机构查询远程查询
    searchOrgName(query) {
      if (query && typeof query == "string") {
        let url = "/shared/sharedSpace/queryListPage";
        let data = {
          pageSize: 30,
          currentPage: 1,
          status: 2,
        };
        const numberReg = /^\d/;
        numberReg.test(query) ? (data.telephone = query) : (data.name = query);
        this.$axios
          .get(url, {
            params: data,
          })
          .then((res) => {
            this.mechanism_name_list = res.data.data;
          })
          .catch((err) => {});
      }
    },
    getVenuesList(query) {
      let url = "/user/masterSetPrice/queryByMessage";
      this.$axios
        .get(url, {
          params: {
            status: 2,
            type: "场馆",
            categories: "体育运动",
            source: "体育宝",
            binding_venues_id: 0,
            title: typeof query == "string" && query != "" ? query : null,
            mechanism_id: this.form.mechanism_id
              ? this.form.mechanism_id
              : null,
          },
        })
        .then((res) => {
          this.venues_list = res.data.data.rows;
        })
        .catch((err) => {});
    },
    getCover(url) {
      this.form.images = url;
    },
    getProductImg(url) {
      this.form.introduction_pic = url;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>